import { Map } from 'immutable';

export function clear(state) {
    return state
        .set('collections', Map())
        .set('items', Map());
}
